<template>
  <!--
    	作者：kmdshop
    	时间：2020-06-20
    	描述：diy组件-参数设置-导航组
    -->
  <div>
    <div class="common-form">
      <span>{{ curItem.name }}</span>
    </div>
    <el-form size="small" :model="curItem" label-width="100px">
      <!--背景颜色-->
      <el-form-item label="背景颜色：">
        <div class="d-s-c">
          <el-color-picker v-model="curItem.style.background"></el-color-picker>
          <el-button
            type="button"
            style="margin-left: 10px;"
            @click.stop="
              $parent.onEditorResetColor(curItem.style, 'btnColor', '#ffffff')
            "
          >
            重置
          </el-button>
        </div>
      </el-form-item>

  <el-form-item label="是否开启底部阴影：">
        <el-radio-group v-model="curItem.style.is_bottom_yy">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="2">不开启</el-radio>
        </el-radio-group>
      </el-form-item>


  <!--顶部距离：-->
      <el-form-item label="外边距顶部距离：">
        <el-input v-model="curItem.style.margin_top"></el-input>
      </el-form-item>
      <!--顶部距离：-->
      <el-form-item label="内边距顶部距离：">
        <el-input v-model="curItem.style.padding_top"></el-input>
      </el-form-item>

      <!--底部距离：-->
      <el-form-item label="底部距离：">
        <el-input v-model="curItem.style.padding_bottom"></el-input>
      </el-form-item>

      <!--宽度-->
      <el-form-item label="宽度">
        <el-input v-model="curItem.style.widtha"></el-input>
      </el-form-item>

           <!--宽度-->
      <el-form-item label="高度">
        <el-input v-model="curItem.style.heighta"></el-input>
      </el-form-item>


      <!--圆角-->
      <el-form-item label="圆角">
        <el-input v-model="curItem.style.border_radius"></el-input>
      </el-form-item>

      <el-form-item  label="两张顶部图">
        <!-- 第一张顶部图 -->
        <div class="top-image-item">
          <div class="icon">
            <img
              v-img-url="curItem.style.img1"
              @click="isAboutLogoUpload = true"
              alt=""
              style="width: 200px;height: 200px;cursor: pointer;"
            />
            <div @click="remove1">移除</div>
          </div>
          <p class="tc gray9">建议尺寸300x100</p>
          <div class="d-s-c mt10">
            <span class="key-name">链接：</span>
            <el-input :value="curItem.style.link1Name" placeholder="未设置链接" disabled style="width: 200px; margin-right: 10px;"></el-input>
            <el-button type="primary" @click="changeTopImageLink(1)">选择链接</el-button>
            <el-button v-if="curItem.style.link1Url" @click="clearTopImageLink(1)" type="text" style="color: #F56C6C;">清除</el-button>
          </div>
        </div>

        <!-- 第二张顶部图 -->
        <div class="top-image-item" style="margin-top: 20px;">
          <div class="icon">
            <img
              v-img-url="curItem.style.img2"
              @click="isAboutLogoUpload2 = true"
              alt=""
              style="width: 200px;height: 200px;cursor: pointer;"
            />
            <div @click="remove2">移除</div>
          </div>
          <p class="tc gray9">建议尺寸300x100</p>
          <div class="d-s-c mt10">
            <span class="key-name">链接：</span>
            <el-input :value="curItem.style.link2Name" placeholder="未设置链接" disabled style="width: 200px; margin-right: 10px;"></el-input>
            <el-button type="primary" @click="changeTopImageLink(2)">选择链接</el-button>
            <el-button v-if="curItem.style.link2Url" @click="clearTopImageLink(2)" type="text" style="color: #F56C6C;">清除</el-button>
          </div>
        </div>
      </el-form-item>

      <!--每行数量-->
      <el-form-item label="每行数量：">
        <el-radio-group v-model="curItem.style.rowsNum">
          <el-radio :label="1">1个</el-radio>
          <el-radio :label="3">3个</el-radio>
          <el-radio :label="4">4个</el-radio>
          <el-radio :label="5">5个</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="图片：">
        <draggable
          class="wrapper"
          v-model="curItem.data"
          :options="{ animation: 120, filter: '.drag__nomove' }"
        >
          <div
            class="param-img-item"
            :key="index"
            v-for="(navBar, index) in curItem.data"
          >

            <div class="delete-box">
              <i
                class="el-icon-delete-solid"
                @click="$parent.onEditorDeleleData(index, selectedIndex)"
              ></i>
            </div>
            <!--背景颜色-->
            <el-form-item label="图标类型：">
              <!-- 选择图案还是icon -->
              <el-radio-group v-model="navBar.icon_type">
                <el-radio :label="10">图标</el-radio>
                <el-radio :label="20">图片</el-radio>
              </el-radio-group>
            </el-form-item>

            <div v-if="Number(navBar.icon_type) === 20">
              <div class="icon">
                <img
                  v-img-url="navBar.imgUrl"
                  alt=""
                  @click="$parent.onEditorSelectImage(navBar, 'imgUrl')"
                />
              </div>
              <p class="tc gray9">建议尺寸100x100</p>
            </div>
            <div v-else>
              <div class="url-box">
                <span class="key-name">图标：</span>
                <selectIcon :icon_text.sync="navBar.icon"></selectIcon>
              </div>
              <div class="url-box">
                <span class="key-name">图标颜色：</span>
                <el-radio-group
                  v-model="navBar.colorConf"
                  style="line-height: 40px"
                >
                  <el-radio :label="30">默认主题色</el-radio>
                  <el-radio :label="10">纯色</el-radio>
                  <el-radio :label="20">渐变色</el-radio>
                </el-radio-group>
              </div>
              <div class="url-box" v-if="Number(navBar.colorConf) === 20">
                <span class="key-name">请选择：</span>
                <el-color-picker v-model="navBar.color1"></el-color-picker>
                <el-color-picker v-model="navBar.color2"></el-color-picker>
                <el-color-picker v-model="navBar.color3"></el-color-picker>
              </div>
              <div class="url-box" v-if="Number(navBar.colorConf) === 10">
                <span class="key-name">请选择：</span>
                <el-color-picker v-model="navBar.solidColor"></el-color-picker>
              </div>
            </div>

            <div class="url-box">
              <span class="key-name">文字内容：</span>
              <el-input v-model="navBar.text"></el-input>
            </div>
            <div class="url-box">
              <span class="key-name">文字颜色：</span>
              <div class="d-s-c">
                <el-color-picker v-model="navBar.font_color"></el-color-picker>
                <el-button
                  type="button"
                  style="margin-left: 10px;"
                  @click.stop="
                    $parent.onEditorResetColor(
                      curItem.style,
                      'btnColor',
                      '#ffffff'
                    )
                  "
                >
                  重置
                </el-button>
              </div>
            </div>
            <div class="d-s-c">
              <div class="url-box flex-1">
                <span class="key-name">链接名称：</span>
                <el-input :value="navBar.name + navBar.linkUrl"></el-input>
              </div>
              <div class="url-box ml10">
                <el-button type="primary" @click="changeLink(index)"
                  >选择链接</el-button
                >
              </div>
            </div>
          </div>
        </draggable>
        <div class="d-c-c">
          <el-button @click="$parent.onEditorAddData">添加一个</el-button>
        </div>
      </el-form-item>
      <SetLink
        v-if="is_linkset"
        :is_linkset="is_linkset"
        @closeDialog="closeLinkSet"
        >选择链接</SetLink
      >
    </el-form>

    <Upload
      v-if="isAboutLogoUpload"
      :config="{ total: 1 }"
      :isupload="isAboutLogoUpload"
      @returnImgs="returnLogoImgsFunc"
      >上传图片</Upload>

    <Upload2
      v-if="isAboutLogoUpload2"
      :config="{ total: 1 }"
      :isupload="isAboutLogoUpload2"
      @returnImgs="returnLogoImgsFunc2"
      >上传图片</Upload2>
  </div>
</template>

<script>
import SetLink from "@/components/setlink/Setlink";
import draggable from "vuedraggable";
import selectIcon from "@/components/page/selectIcon";
import Upload from "@/components/file/Upload";
import Upload2 from "@/components/file/Upload";
import { remove } from "lodash";

export default {
  components: {
    SetLink,
    draggable,
    selectIcon,
    Upload,
    Upload2,
  },
  data() {
    return {
      /*是否选择链接*/
      is_linkset: false,
      index: null,
      currentTopImage: null, // 当前操作的顶部图编号

      isAboutLogoUpload: false,
      isAboutLogoUpload2: false,
    };
  },
  props: ["curItem", "selectedIndex", "opts"],
  methods: {
    remove1(){
      this.curItem.style.img1 = "";
    },
    remove2(){
      this.curItem.style.img2 = "";
    },
    
    // 上传logo图片
    returnLogoImgsFunc(e) {
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        e.forEach(element => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach(e => {
            if (e === ext) {
              prevent = true;
              return false;
            }
          });
        });
        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }
 
        this.curItem.style.img1 = e[0].file_path;
      }
      this.isAboutLogoUpload = false;
    },
    
    // 上传logo图片
    returnLogoImgsFunc2(e) {
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        e.forEach(element => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach(e => {
            if (e === ext) {
              prevent = true;
              return false;
            }
          });
        });
        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }
 
        this.curItem.style.img2 = e[0].file_path;
      }
      this.isAboutLogoUpload2 = false;
    },
    
    /*选择顶部图链接*/
    changeTopImageLink(imageNumber) {
      this.is_linkset = true;
      this.currentTopImage = imageNumber;
    },
    
    /*清除顶部图链接*/
    clearTopImageLink(imageNumber) {
      if (imageNumber === 1) {
        this.curItem.style.link1Url = '';
        this.curItem.style.link1Name = '';
      } else if (imageNumber === 2) {
        this.curItem.style.link2Url = '';
        this.curItem.style.link2Name = '';
      }
      this.$message.success('链接已清除');
    },

    /*选择链接*/
    changeLink(index) {
      this.is_linkset = true;
      this.index = index;
    },

    /*获取链接并关闭弹窗*/
    closeLinkSet(e) {
      if (e) {
        if (this.currentTopImage !== null) {
          // 设置顶部图链接
          if (this.currentTopImage === 1) {
            this.curItem.style.link1Url = e.url;
            this.curItem.style.link1Name = "链接到" + " " + e.type + " " + e.name;
          } else if (this.currentTopImage === 2) {
            this.curItem.style.link2Url = e.url;
            this.curItem.style.link2Name = "链接到" + " " + e.type + " " + e.name;
          }
          this.currentTopImage = null;
        } else {
          // 设置普通导航项链接
          this.curItem.data[this.index].linkUrl = e.url;
          this.curItem.data[this.index].name = "链接到" + " " + e.type + " " + e.name;
          if (e.appid) {
            this.curItem.data[this.index].appid = e.appid;
          }
        }
      }
      this.is_linkset = false;
    }
  }
};
</script>

<style scoped>
.top-image-item {
  border: 1px dashed #ddd;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 15px;
}

.top-image-item .icon {
  position: relative;
  display: inline-block;
}

.top-image-item .icon div {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  text-align: center;
  cursor: pointer;
  padding: 5px;
}

.mt10 {
  margin-top: 10px;
}

.key-name {
  min-width: 60px;
  text-align: right;
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/page/page/diy/params/NavBar.vue